import { Group } from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons-react';

import { ChatMessage } from '#core/components/chat/messages/ChatMessage';
import { type ToolComponentProps, useTool } from '#core/components/chat/tool';
import { useCogniteFunction } from '#core/hooks/fusion/useCogniteFunction';

import { ResChemFunction } from '#schema/function/ResChemFunction';

export function useResChemFunctionTool() {
  const fn = useCogniteFunction(ResChemFunction);

  return useTool(
    'predict_ion_concentration',
    'Use this tool to predict the ion concentration using Specific Gravity (SG). The model name is ResChem.',
    ResChemFunction.request.shape.ml_inputs,
    async ({ args, setContext }) => {
      setContext({ status: 'idle' });
      const data = await fn.call({ ml_inputs: args }, (status) => {
        setContext({ status });
      });
      return { message: data };
    },
    toolComponent,
  );
}

function toolComponent(_props: ToolComponentProps) {
  return (
    <ChatMessage role="assistant" kind="subtle">
      <Group gap="xs" align="center">
        <IconCircleCheck size={16} /> ResChem model executed successfully.
      </Group>
    </ChatMessage>
  );
}
